// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useCurrentUserIsGuest, useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC } from "react";
import { css } from "styled-components";

export interface OnePageCheckoutSignInMessageProps extends WidgetProps {}

export interface OnePageCheckoutSignInMessageStyles {
    infosBox?: InfosBoxProps;
    wrapper?: InjectableCss;
    signInText?: TypographyPresentationProps;
    signInButton?: ButtonPresentationProps;
}

export const onePageCheckoutSignInMessageStyles: OnePageCheckoutSignInMessageStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-flow: row wrap;
            flex: 1 0 100%;
            justify-content: space-between;
            align-items: center;
            gap: ${pxToRem(8)};
        `,
    },
    signInButton: { sizeVariant: "small" },
};

const styles = onePageCheckoutSignInMessageStyles;

const OnePageCheckoutSignInMessage: FC<OnePageCheckoutSignInMessageProps> = () => {
    const signInUrl = usePageLinkByPageType(constants.pageType.signIn)?.url;
    const history = useHistory();
    const location = useLocation();
    const returnUrl = location.pathname + location.search;
    const { accountSettings } = useSettingsCollection();
    const allowGuestCheckout = accountSettings.allowGuestCheckout && useCurrentUserIsGuest();

    if (!allowGuestCheckout) {
        return null;
    }

    const signInClickHandler = () => {
        history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`);
    };

    return (
        <InfosBox {...styles.infosBox}>
            <StyledWrapper {...styles.wrapper}>
                <Typography {...styles.signInText}>{siteMessage("One_Page_Checkout_SingIn_Message")}</Typography>
                <Button {...styles.signInButton} onClick={signInClickHandler}>
                    {translate("Sign In")}
                </Button>
            </StyledWrapper>
        </InfosBox>
    );
};

const widgetModule: WidgetModule = {
    component: OnePageCheckoutSignInMessage,
    definition: {
        displayName: "Sign In Message",
        group: "One Page Checkout",
        allowedContexts: ["OnePageCheckoutPage"],
    },
};

export default widgetModule;
